import React, { Fragment, useCallback, useState, useEffect, useContext } from 'react';
import { Container, Row, Col, Label, Input, Button } from 'reactstrap';
import styles from './ShopPlan.module.css';
import MainPlanCard from './MainPlanCard';
import classNames from 'classnames';
import AdditionalPlanCard from './AdditionalPlanCard';
import { useHistory } from 'react-router';
//import Select from 'react-select/src/Select';
import Select from 'react-select';
import { SalesContext } from '../contexts/SalesContext';
import PlanBenefits from '../Vendor/NJR/PlanOptions/PlanBenefits';
import { dataLayerPush } from '../../helpers';
import { usePageTitle } from '../_ReactHooks';
import { BrandingContext } from '../contexts/ContractContext';
import getClientContent from '../_BrandingProvider/brandContent';
import { stripPhoneNumber } from '../shared/util';
import PlanSelection from './PlanSelection';

const ShopPlan = () => {
    usePageTitle('Select A Plan');

    useEffect(() => {
        getRiskProfileListByMasterProgramId(20);
        getPlanOptionsListByMasterProgramId(20);
        dataLayerPush('Pageview', {
            pagePath: '/selectPlan',
            pageTitle: 'NJR Retail Service Plans - Select A Plan'
        });
    }, []);

    const [plan, setPlan] = useState('monthly');
    const [planTotal, setPlanTotal] = useState(0.0);
    const [additionalTotal, setAdditionalTotal] = useState(0.0);
    const [activePlan, setActivePlan] = useState(null);
    const [activeAddPlans, setactiveAddPlans] = useState([]);
    const [selectedPlan, setSelectedPlan] = useState([]);
    const [selectedAddPlans, setSelectedAddPlans] = useState([]);
    const [riskProfile, setRiskProfile] = useState(null);
    const history = useHistory();
    const context = useContext(SalesContext);
    const [total, setTotal] = useState(0.0);
    const branding = useContext(BrandingContext);
    const clientId = branding.contract || 'NJR';
    const { variableText } = getClientContent(clientId);
    const phoneNumber = variableText.customerService.phone;
    const [showPlanSelection, setShowPlanSelection] = useState(false);

    const [NJRConfigurations, setNJRConfigurations] = useState([]);
    const [addOns, setAddOns] = useState([]);
    const [yearlyAddOns, setYearlyAddOns] = useState([]);
    const [appliances, setAppliances] = useState([]);
    const [tsf, setTsf] = useState([]);
    const [shopPlanData, setShopPlanData] = useState({
        plan: '',
        planTotal: 0.0,
        additionalTotal: 0.0,
        activePlan: null,
        activeAddPlans: null,
        selectedPlanInfo: {
            includes: null,
            monthly: null,
            riskProfile: null,
            title: null,
            yearly: null
        },
        selectedAddPlans: null,
        riskProfile: null
    });

    const handleRoute = () => {
        if (plan != context.data.planData.plan || activePlan != context.data.planData.activePlan) {
            context.updatePromoCode(null);
        }

        context.updatePlanData({
            plan,
            activePlan,
            activeAddPlans,
            selectedPlan,
            selectedAddPlans,
            additionalTotal,
            planTotal
        });

        // ===== GOOGLE TAG MANAGER FOR ENHANCED ECOMMERCE ANALYTICS =====
        const addPlansForGtm = [];
        selectedAddPlans.map((aP, i) =>
            addPlansForGtm.push({
                item_id: activeAddPlans[i],
                item_name: aP.title,
                item_category: 'add_on_plan',
                price: plan === 'monthly' ? aP.monthly : aP.yearly
            })
        );
        dataLayerPush(null, { ecommerce: null }); // clear last ecommerce data
        dataLayerPush('add_to_cart', {
            ecommerce: {
                currency: 'USD',
                value: planTotal + additionalTotal,
                paymentPlan: plan,
                items: [
                    {
                        item_id: activePlan,
                        item_name: selectedPlan.title,
                        item_category: 'primary_plan',
                        includes: selectedPlan.includes,
                        price: plan === 'monthly' ? selectedPlan.monthly : selectedPlan.yearly
                    },
                    ...addPlansForGtm
                ]
            }
        });
        // ========= END GOOGLE TAG MANAGER ==================

        history.push('/customerinfo');
    };

    const handleAddToCart = () => {
        setShowPlanSelection(true);
    };

    const onChangePlanHandler = () => {
        setShowPlanSelection(false);
    };

    const onPlanSelect = useCallback(
        (addPlan, selectedProduct, selectedPlan) => {
            const price = selectedProduct[selectedPlan];
            if (!price) {
                return;
            }
            var addOns;

            dataLayerPush('select_item', {
                ecommerce: {
                    currency: 'USD',
                    value: price,
                    paymentPlan: selectedPlan,
                    items: [
                        {
                            item_name: selectedProduct.title,
                            item_id: addPlan,
                            includes: selectedProduct.includes,
                            item_category: 'primary_plan',
                            price
                        }
                    ]
                }
            });
            let tsfList = [];
            if (selectedProduct?.riskProfile?.tsf != null) {
                tsfList = [
                    {
                        term: Math.max(...selectedProduct?.riskProfile?.tsf),
                        price: selectedProduct.riskProfile?.higherTsfTotalPrice,
                        name: 'higher',
                        yearlyPrice: selectedProduct?.yearlyRiskProfile?.higherTsfTotalPrice
                    },
                    {
                        term: Math.min(...selectedProduct?.riskProfile?.tsf),
                        price: selectedProduct.riskProfile?.lowerTsfTotalPrice,
                        name: 'lower',
                        yearlyPrice: selectedProduct?.yearlyRiskProfile?.lowerTsfTotalPrice
                    }
                ];
            }
            setTsf(tsfList);

            setActivePlan(addPlan);
            setSelectedPlan(selectedProduct);
            if (addPlan == 'laundry') {
                setactiveAddPlans([]);
                setSelectedAddPlans([]);
                setAdditionalTotal(0.0);
            }
            setPlanTotal(selectedProduct[selectedPlan]);
            setShopPlanData({
                ...shopPlanData,
                plan: plan,
                planTotal: planTotal,
                additionalTotal: additionalTotal,
                activePlan: activePlan,
                activeAddPlans: activeAddPlans,
                selectedAddPlans: selectedAddPlans,
                riskProfile: riskProfile,
                selectedPlanInfo: {
                    //...selectedPlanInfo,
                    includes: selectedPlan?.includes,
                    monthly: selectedPlan?.monthly,
                    //riskProfile: selectedPlan?.riskProfile,
                    title: selectedPlan?.title,
                    yearly: selectedPlan?.yearly
                }
            });
        },
        [activePlan, setActivePlan, selectedPlan, planTotal, additionalTotal, selectedAddPlans, plan]
    );

    const onAddPlanSelect = useCallback(
        (addPlan, selectedProduct, selectedPlan) => {
            const planPos = activeAddPlans.indexOf(addPlan);
            const price = selectedProduct[selectedPlan];

            // REMOVE ADD-ON PLAN IF ALREADY PRESENT
            if (planPos > -1) {
                console.log('=== planPos ===', planPos);
                activeAddPlans.splice(planPos, 1);
                selectedAddPlans.splice(planPos, 1);
                setAdditionalTotal(additionalTotal - parseFloat(selectedProduct[selectedPlan]));

                // DO WE NEED TO DO A GA EVENT IN THIS CASE, WHEN IT IS DESELECTED?
                // dataLayerPush('select_item', {
                //     ecommerce: {
                //         currency: "USD",
                //         value: planTotal,
                //         paymentPlan: selectedPlan,
                //         items: [
                //             {
                //                 item_name: selectedProduct.title,
                //                 item_id: addPlan,
                //                 includes: selectedProduct.includes,
                //                 item_category: 'add_on_plan',
                //                 price,
                //             }
                //         ]
                //     }
                // })
            }
            // ELSE ADD IT TO THE LIST
            else {
                activeAddPlans.push(addPlan);
                selectedAddPlans.push(selectedProduct);
                setAdditionalTotal(additionalTotal + parseFloat(selectedProduct[selectedPlan]));
                dataLayerPush('select_item', {
                    ecommerce: {
                        currency: 'USD',
                        value: price,
                        paymentPlan: selectedPlan,
                        items: [
                            {
                                item_name: selectedProduct.title,
                                item_id: addPlan,
                                includes: selectedProduct.includes,
                                item_category: 'add_on_plan',
                                price
                            }
                        ]
                    }
                });
            }

            setactiveAddPlans([...activeAddPlans]);
            setSelectedAddPlans([...selectedAddPlans]);

            setShopPlanData({
                ...shopPlanData,
                plan: plan,
                planTotal: planTotal,
                additionalTotal: additionalTotal,
                activePlan: activePlan,
                activeAddPlans: activeAddPlans,
                selectedAddPlans: [...selectedAddPlans],
                riskProfile: riskProfile,
                selectedPlanInfo: {
                    //...selectedPlanInfo,
                    includes: selectedPlan?.includes,
                    monthly: selectedPlan?.monthly,
                    riskProfile: selectedPlan?.riskProfile,
                    title: selectedPlan?.title,
                    yearly: selectedPlan?.yearly
                }
            });
        },
        [activeAddPlans, setactiveAddPlans, selectedPlan, selectedAddPlans, planTotal, additionalTotal]
    );

    let kitchenMonthly = [{ totalBundlePrice: null }];
    let kitchenYearly = [{ totalBundlePrice: null }];
    let laundryMonthly = [{ totalBundlePrice: null }];
    let laundryYearly = [{ totalBundlePrice: null }];
    let kitchenAndLaundryMonthly = [{ totalBundlePrice: null }];
    let kitchenAndLaundryYearly = [{ totalBundlePrice: null }];
    let refrigeratorMonthly = [{ totalBundlePrice: null }];
    let refrigeratorYearly = [{ totalBundlePrice: null }];
    let cookingMonthly = [{ totalBundlePrice: null }];
    let cookingYearly = [{ totalBundlePrice: null }];
    let microwaveMonthly = [{ totalBundlePrice: null }];
    let microwaveYearly = [{ totalBundlePrice: null }];
    let standaloneFreezerMonthly = [{ totalBundlePrice: null }];
    let standaloneFreezerYearly = [{ totalBundlePrice: null }];
    if (riskProfile != null) {
        kitchenMonthly = riskProfile.filter((rp) => rp.riskProfileId == NJRConfigurations.kitchenMonthly)[0];
        kitchenYearly = riskProfile.filter((rp) => rp.riskProfileId == NJRConfigurations.kitchenYearly)[0];
        laundryMonthly = riskProfile.filter((rp) => rp.riskProfileId == NJRConfigurations.laundryMonthly)[0];
        laundryYearly = riskProfile.filter((rp) => rp.riskProfileId == NJRConfigurations.laundryYearly)[0];
        kitchenAndLaundryMonthly = riskProfile.filter(
            (rp) => rp.riskProfileId == NJRConfigurations.kitchenAndLaundryMonthly
        )[0];
        kitchenAndLaundryYearly = riskProfile.filter(
            (rp) => rp.riskProfileId == NJRConfigurations.kitchenAndLaundryYearly
        )[0];
        refrigeratorMonthly = riskProfile.filter((rp) => rp.riskProfileId == NJRConfigurations.refrigeratorMonthly)[0];
        refrigeratorYearly = riskProfile.filter((rp) => rp.riskProfileId == NJRConfigurations.refrigeratorYearly)[0];
        cookingMonthly = riskProfile.filter((rp) => rp.riskProfileId == NJRConfigurations.cookingMonthly)[0];
        cookingYearly = riskProfile.filter((rp) => rp.riskProfileId == NJRConfigurations.cookingYearly)[0];
        microwaveMonthly = riskProfile.filter((rp) => rp.riskProfileId == NJRConfigurations.microwaveMonthly)[0];
        microwaveYearly = riskProfile.filter((rp) => rp.riskProfileId == NJRConfigurations.microwaveYearly)[0];
        standaloneFreezerMonthly = riskProfile.filter(
            (rp) => rp.riskProfileId == NJRConfigurations.addOnFreezerMonthly
        )[0];
        standaloneFreezerYearly = riskProfile.filter(
            (rp) => rp.riskProfileId == NJRConfigurations.addOnFreezerYearly
        )[0];
    }

    const getRiskProfileFromAPI = useCallback(() => {
        let clientId = 'NJR';
        fetch(`api/pricing/riskProfile/getByMasterProgramId/20/16/${clientId}`)
            .then((res) => res.json())
            .then(
                (data) => {
                    setRiskProfile(data);
                    console.log(data);
                    let monthlyPlans = data?.filter((rp) => rp.termId === 15);
                    let Addon = [];
                    let AddonYearly = [];
                    let yearlyPlans = data?.filter((rp) => rp.termId === 2);
                    let addOnProductsMonthly = monthlyPlans?.filter(
                        (mp) => mp.name?.includes('Add-On') || mp.name?.includes('Additional')
                    );
                    let addOnProductsYearly = yearlyPlans?.filter(
                        (yp) => yp.name?.includes('Add-On') || yp.name?.includes('Additional')
                    );
                    let selectedPlan = plan == 'monthly' ? addOnProductsMonthly : addOnProductsYearly;
                    let name = '';
                    let index = null;
                    selectedPlan.forEach((plan) => {
                        let addOnData = {
                            name: plan.description?.includes('Secondary Refrigerator')
                                ? 'Refrigerator'
                                : plan.description?.includes('Secondary Cooking Product')
                                  ? 'Cooking Product'
                                  : plan.description?.includes('Secondary Built-in Microwave')
                                    ? 'Built-in Microwave'
                                    : plan.description?.includes('Secondary Freezer')
                                      ? 'Standalone Freezer'
                                      : plan.name,
                            title: plan.description,
                            riskProfile: plan,
                            lowerTsfPrice: plan?.lowerTsfTotalPrice,
                            higherTsfPrice: plan?.higherTsfTotalPrice,
                            id: plan.riskProfileId,
                            ind: plan.description?.includes('Secondary Refrigerator')
                                ? 2
                                : plan.description?.includes('Secondary Cooking Product')
                                  ? 1
                                  : plan.description?.includes('Secondary Built-in Microwave')
                                    ? 0
                                    : plan.description?.includes('Secondary Freezer')
                                      ? 3
                                      : null
                        };
                        Addon.push(addOnData);
                    });
                    setAddOns([...Addon]);
                    addOnProductsYearly.forEach((plan) => {
                        let addOnYearlyData = {
                            name: plan.description?.includes('Secondary Refrigerator')
                                ? 'Refrigerator'
                                : plan.description?.includes('Secondary Cooking Product')
                                  ? 'Cooking Product'
                                  : plan.description?.includes('Secondary Built-in Microwave')
                                    ? 'Built-in Microwave'
                                    : plan.description?.includes('Secondary Freezer')
                                      ? 'Standalone Freezer'
                                      : plan.name,
                            title: plan.description,
                            riskProfile: plan,
                            lowerTsfPrice: plan?.lowerTsfTotalPrice,
                            higherTsfPrice: plan?.higherTsfTotalPrice,
                            id: plan.riskProfileId,
                            ind: plan.description?.includes('Secondary Refrigerator')
                                ? 2
                                : plan.description?.includes('Secondary Cooking Product')
                                  ? 1
                                  : plan.description?.includes('Secondary Built-in Microwave')
                                    ? 0
                                    : plan.description?.includes('Secondary Freezer')
                                      ? 3
                                      : null
                        };
                        AddonYearly.push(addOnYearlyData);
                    });
                    setYearlyAddOns([...AddonYearly]);
                    // let addOnProducts = data?.filter(rp => rp.termId === contract.riskProfile.termId)
                    //     .filter(mp => mp.name?.includes("Add-On") || mp.name?.includes("Additional"));
                },
                [riskProfile]
            );
    });
    const getRiskProfileListByMasterProgramId = useCallback((masterProgramId) => {
        fetch(`api/pricing/riskProfile/getRiskProfilesFromConfig/${masterProgramId}`)
            .then((res) => res.json())
            .then(
                (data) => {
                    setNJRConfigurations(data);
                },
                [NJRConfigurations]
            );
    });
    const getPlanOptionsListByMasterProgramId = useCallback((masterProgramId) => {
        fetch(`api/pricing/riskProfile/getPlanOptionsFromConfig/${masterProgramId}`)
            .then((res) => res.json())
            .then(
                (data) => {
                    setAppliances(data);
                    console.log(data);
                },
                [appliances]
            );
    });
    console.log(appliances);
    const loadPlanData = () => {
        setPlan(context.data.planData.plan);
        setActivePlan(context.data.planData.activePlan);
        setactiveAddPlans(context.data.planData.activeAddPlans);
        setSelectedPlan(context.data.planData.selectedPlan);
        setSelectedAddPlans(context.data.planData.selectedAddPlans);
        setAdditionalTotal(context.data.planData.additionalTotal);
        setPlanTotal(context.data.planData.planTotal);
    };

    useEffect(() => {
        getRiskProfileFromAPI();
        if (context.data.planData) loadPlanData();
    }, []);

    useEffect(() => {
        const allPlans = [...selectedAddPlans, selectedPlan];
        const total = allPlans.reduce((tot, val) => tot + val[plan], 0);
        const planTotal = plan == 'yearly' ? selectedPlan.yearly : selectedPlan.monthly;
        if (!isNaN(total)) {
            setTotal(total);
        }
        setPlanTotal(planTotal);
    }, [plan, selectedPlan, selectedAddPlans, setTotal, riskProfile]);
    console.log(plan, selectedPlan, selectedAddPlans, riskProfile);

    return (
        <Container className={styles.planOptions}>
            <div className={classNames(styles.njrHero)}>
                <h1 className={styles.title}>Build a plan that fits your needs.</h1>
                <div className={styles.tagLine}>
                    Need help? Call{' '}
                    <a
                        href={`tel:${stripPhoneNumber(phoneNumber)}`}
                        aria-label='Customer service phone number'
                    >
                        {phoneNumber}
                    </a>
                    .
                </div>
            </div>

            <div className={styles.cardRow}>
                {!showPlanSelection ? (
                    <div className={classNames(styles.planOptionWrapper, 'mb-3 mb-md-5')}>
                        <div className={styles.planOptionsMenu}>
                            <Row>
                                <Col
                                    md='6'
                                    className='col-lg mb-3'
                                >
                                    <MainPlanCard
                                        product='total'
                                        plan={plan}
                                        activePlan={activePlan}
                                        monthlyPrice={kitchenAndLaundryMonthly?.higherTsfTotalPrice}
                                        yearlyPrice={kitchenAndLaundryYearly?.higherTsfTotalPrice}
                                        riskProfile={
                                            plan === 'monthly' ? kitchenAndLaundryMonthly : kitchenAndLaundryYearly
                                        }
                                        yearlyRiskProfile={kitchenAndLaundryYearly}
                                        onSelect={onPlanSelect}
                                    />
                                </Col>
                                <Col
                                    md='6'
                                    className='col-lg mb-3'
                                >
                                    <MainPlanCard
                                        product='kitchen'
                                        plan={plan}
                                        activePlan={activePlan}
                                        monthlyPrice={kitchenMonthly?.higherTsfTotalPrice}
                                        yearlyPrice={kitchenYearly?.higherTsfTotalPrice}
                                        riskProfile={plan === 'monthly' ? kitchenMonthly : kitchenYearly}
                                        yearlyRiskProfile={kitchenYearly}
                                        onSelect={onPlanSelect}
                                    />
                                </Col>
                                <Col
                                    md='6'
                                    className='col-lg mb-3'
                                >
                                    <MainPlanCard
                                        product='laundry'
                                        plan={plan}
                                        activePlan={activePlan}
                                        monthlyPrice={laundryMonthly?.higherTsfTotalPrice}
                                        yearlyPrice={laundryYearly?.higherTsfTotalPrice}
                                        riskProfile={plan === 'monthly' ? laundryMonthly : laundryYearly}
                                        yearlyRiskProfile={laundryYearly}
                                        onSelect={onPlanSelect}
                                    />
                                </Col>
                            </Row>
                            <div className={styles.total}>
                                <p className={styles.totalAmount}>
                                    Total: ${total.toFixed(2)}/{plan === 'yearly' ? 'yr' : 'mo'}
                                </p>
                                <button
                                    className={classNames('btn btn-primary')}
                                    onClick={handleAddToCart}
                                    disabled={activePlan === null}
                                >
                                    Add to Cart
                                </button>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className={classNames(styles.planOptionSelectionWrapper, 'mb-3 mb-md-5')}>
                        <PlanSelection
                            activePlan={activePlan}
                            activeAddPlans={activeAddPlans}
                            selectedAddPlans={selectedAddPlans}
                            selectedProduct={selectedPlan}
                            handleChangePlan={onChangePlanHandler}
                            additionalPlans={addOns}
                            additionalPlansYearly={yearlyAddOns}
                            plan={plan}
                            activeTsf={tsf}
                            assetsCovered={appliances}
                        />
                    </div>
                )}
            </div>
            <PlanBenefits />
        </Container>
    );
};

export default ShopPlan;
